// 2026-10-14 NAMI-RENSA: 古いブラウザ（Chrome 80未満、Android 8 など）でも読めるよう、Dawn 標準のコードを esbuild（target=chrome60）で変換。変換前のコードは控えに保存してある
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        __publicField(this, "quantityInput");
        __publicField(this, "quantityForm");
        __publicField(this, "onVariantChangeUnsubscriber");
        __publicField(this, "cartUpdateUnsubscriber");
        __publicField(this, "abortController");
        __publicField(this, "pendingRequestUrl", null);
        __publicField(this, "preProcessHtmlCallbacks", []);
        __publicField(this, "postProcessHtmlCallbacks", []);
        this.quantityInput = this.querySelector(".quantity__input");
      }
      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent("product-info:loaded", { bubbles: true }));
      }
      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }
      initQuantityHandlers() {
        if (!this.quantityInput)
          return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm)
          return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }
      disconnectedCallback() {
        var _a;
        this.onVariantChangeUnsubscriber();
        (_a = this.cartUpdateUnsubscriber) == null ? void 0 : _a.call(this);
      }
      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push(
          (html) => html.querySelectorAll(".scroll-trigger").forEach((element) => element.classList.add("scroll-trigger--cancel"))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          var _a, _b, _c;
          (_b = (_a = window == null ? void 0 : window.Shopify) == null ? void 0 : _a.PaymentButton) == null ? void 0 : _b.init();
          (_c = window == null ? void 0 : window.ProductModel) == null ? void 0 : _c.loadShopifyXR();
        });
      }
      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target))
          return;
        this.resetProductFormState();
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === "true" && shouldSwapProduct;
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct ? this.handleSwapProduct(productUrl, shouldFetchFullPage) : this.handleUpdateProductInfo(productUrl)
        });
      }
      resetProductFormState() {
        const productForm = this.productForm;
        productForm == null ? void 0 : productForm.toggleSubmitButton(true);
        productForm == null ? void 0 : productForm.handleErrorMessage();
      }
      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          var _a;
          (_a = this.productModal) == null ? void 0 : _a.remove();
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : "product-info";
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant == null ? void 0 : variant.id);
          if (updateFullPage) {
            document.querySelector("head title").innerHTML = html.querySelector("head title").innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }
      renderProductInfo({ requestUrl, targetId, callback }) {
        var _a;
        (_a = this.abortController) == null ? void 0 : _a.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal }).then((response) => response.text()).then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(responseText, "text/html");
          callback(html);
        }).then(() => {
          var _a2;
          (_a2 = document.querySelector(`#${targetId}`)) == null ? void 0 : _a2.focus();
        }).catch((error) => {
          if (error.name === "AbortError") {
            console.log("Fetch aborted by user");
          } else {
            console.error(error);
          }
        });
      }
      getSelectedVariant(productInfoNode) {
        var _a;
        const selectedVariant = (_a = productInfoNode.querySelector("variant-selects [data-selected-variant]")) == null ? void 0 : _a.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }
      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }
        return `${url}?${params.join("&")}`;
      }
      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-selects");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }
      handleUpdateProductInfo(productUrl) {
        return (html) => {
          var _a, _b, _c, _d, _e, _f, _g;
          const variant = this.getSelectedVariant(html);
          (_a = this.pickupAvailability) == null ? void 0 : _a.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant == null ? void 0 : variant.id);
          this.updateVariantInputs(variant == null ? void 0 : variant.id);
          if (!variant) {
            this.setUnavailable();
            return;
          }
          this.updateMedia(html, (_b = variant == null ? void 0 : variant.featured_media) == null ? void 0 : _b.id);
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle("hidden", shouldHide(source));
            }
          };
          updateSourceFromDestination("price");
          updateSourceFromDestination("Sku", ({ classList }) => classList.contains("hidden"));
          updateSourceFromDestination("Inventory", ({ innerText }) => innerText === "");
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("Price-Per-Item", ({ classList }) => classList.contains("hidden"));
          this.updateQuantityRules(this.sectionId, html);
          (_c = this.querySelector(`#Quantity-Rules-${this.dataset.section}`)) == null ? void 0 : _c.classList.remove("hidden");
          (_d = this.querySelector(`#Volume-Note-${this.dataset.section}`)) == null ? void 0 : _d.classList.remove("hidden");
          (_g = this.productForm) == null ? void 0 : _g.toggleSubmitButton(
            (_f = (_e = html.getElementById(`ProductSubmitButton-${this.sectionId}`)) == null ? void 0 : _e.hasAttribute("disabled")) != null ? _f : true,
            window.variantStrings.soldOut
          );
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant
            }
          });
        };
      }
      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId != null ? variantId : "";
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
      updateURL(url, variantId) {
        var _a;
        (_a = this.querySelector("share-button")) == null ? void 0 : _a.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ""}`
        );
        if (this.dataset.updateUrl === "false")
          return;
        window.history.replaceState({}, "", `${url}${variantId ? `?variant=${variantId}` : ""}`);
      }
      setUnavailable() {
        var _a;
        (_a = this.productForm) == null ? void 0 : _a.toggleSubmitButton(true, window.variantStrings.unavailable);
        const selectors = ["price", "Inventory", "Sku", "Price-Per-Item", "Volume-Note", "Volume", "Quantity-Rules"].map((id) => `#${id}-${this.dataset.section}`).join(", ");
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add("hidden"));
      }
      updateMedia(html, variantFeaturedMediaId) {
        var _a, _b, _c;
        if (!variantFeaturedMediaId)
          return;
        const mediaGallerySource = this.querySelector("media-gallery ul");
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
        const refreshSourceData = () => {
          if (this.hasAttribute("data-zoom-on-hover"))
            enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll("li[data-media-id]"));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };
        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll("li[data-media-id]")
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }
          if (shouldRefresh)
            [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }
        (_b = (_a = this.querySelector(`media-gallery`)) == null ? void 0 : _a.setActiveMedia) == null ? void 0 : _b.call(
          _a,
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );
        const modalContent = (_c = this.productModal) == null ? void 0 : _c.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent)
          modalContent.innerHTML = newModalContent.innerHTML;
      }
      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1
        };
        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null)
          min = Math.min(min, max);
        if (data.cartQuantity >= data.min)
          min = Math.min(min, data.step);
        this.quantityInput.min = min;
        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute("max");
        }
        this.quantityInput.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, void 0);
      }
      fetchQuantityRules() {
        var _a, _b;
        const currentVariantId = (_b = (_a = this.productForm) == null ? void 0 : _a.variantIdInput) == null ? void 0 : _b.value;
        if (!currentVariantId)
          return;
        this.querySelector(".quantity__rules-cart .loading__spinner").classList.remove("hidden");
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`).then((response) => response.text()).then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          this.updateQuantityRules(this.dataset.section, html);
        }).catch((e) => console.error(e)).finally(() => this.querySelector(".quantity__rules-cart .loading__spinner").classList.add("hidden"));
      }
      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput)
          return;
        this.setQuantityBoundries();
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated)
            continue;
          if (selector === ".quantity__input") {
            const attributes = ["data-cart-quantity", "data-min", "data-max", "step"];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
            if (selector === ".quantity__label") {
              const updatedAriaLabelledBy = updated.getAttribute("aria-labelledby");
              if (updatedAriaLabelledBy) {
                current.setAttribute("aria-labelledby", updatedAriaLabelledBy);
                const labelId = updatedAriaLabelledBy;
                const currentHiddenLabel = document.getElementById(labelId);
                const updatedHiddenLabel = html.getElementById(labelId);
                if (currentHiddenLabel && updatedHiddenLabel) {
                  currentHiddenLabel.textContent = updatedHiddenLabel.textContent;
                }
              }
            }
          }
        }
      }
      get productForm() {
        return this.querySelector(`product-form`);
      }
      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }
      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }
      get variantSelectors() {
        return this.querySelector("variant-selects");
      }
      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "related-products"
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }
      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          "quick_order_list"
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
